enum TagType {
    Task = 1,
    Document = 2
}

export default TagType;